import type { InventoryListingRow } from 'types/api-responses';
import { type TypeCurvesListingFilters } from './use-type-curves-listing';
import { useListingQuery } from './hooks';

/**
 * The Inventory Workspaces view of the shared listing query.
 *
 * Same endpoint as the Type Curves, Workspaces and Scenarios tabs — only the
 * `view` differs, per the spec: "a new view on the existing query". Rows are
 * zone-grained, so `totalCount` is the WORKSPACES count (the paginator's), not
 * `rows.length`, which exceeds it whenever a workspace spans several zones.
 *
 * @param {TypeCurvesListingFilters} filters - Shared filter-panel state.
 * @param {{ enabled: boolean }} options - Only the active tab fetches.
 * @return {object} Rows, count, facets, status and the shared table handlers.
 */
export function useInventoryWorkspacesListing(
  filters: TypeCurvesListingFilters,
  options: { enabled: boolean }
) {
  return useListingQuery<InventoryListingRow>(
    'inventories',
    'inventory-ws-listing',
    filters,
    options
  );
}
